import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Grid,
  Card,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack
} from "@mui/material/";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { style } from "style";
import moment from 'moment';
import CustomExport from "components/CustomExport";
import { checkResponse } from "helpers/notification";
import { UserManagementAPI } from "API/UserManagementAPI";
import { alertSuccessText } from "helpers/notification";
import Icon from "@mui/material/Icon";
import { alertErrorText } from "helpers/notification";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

function UserManagement() {
  // consts
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [list, setList] = useState([]);

  const [clusterId, setClusterId] = useState(0);
  const [name, setName] = useState("");
  const [surName, setSurName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  const [selectedUser, setSelectedUser] = useState(null);
  const [editUserDialogOpen, setEditUserDialogOpen] = useState(false);
  const [deleteUserDialogOpen, setDeleteUserDialogOpen] = useState(false);

  var groupEuId = useSelector(state => state.common.groupEuId);
  var userName = useSelector(state => state.common.userName);

  const formatTRPhone = (value) => {
    if (!value) return "";
    const digits = String(value).replace(/\D/g, "");
    const ten = digits.startsWith("0090") ? digits.slice(4, 14) : digits.slice(0, 10);
    if (ten.length !== 10) return value;
    return `${ten.slice(0, 3)} ${ten.slice(3, 6)} ${ten.slice(6, 8)} ${ten.slice(8, 10)}`;
  };

  const rowStyle = {
    display: "flex",
    alignItems: "center",
    gap: 12,
    marginBottom: 10,
  };

  const labelStyle = {
    width: 90,
    margin: 0,
    fontWeight: 600,
  };

  const inputWrapStyle = {
    flex: 1,
  };


  useEffect(() => {
    const createRowsAndColoumns = async e => {
      const rowsData = [];

      if (list.length > 0) {

        list.map(data => {

          rowsData.push({
            id: data.clusterId,
            clusterId: data.clusterId,
            groupEuId: data.groupEuId,
            name: data.name,
            surname: data.surname,
            phone: data.phone,
            email: data.email,
            insertDate: data.insertDate,
          })
        });
      }
      setRows(rowsData);

      setColumns([
        {
          headerName: "Id", field: "clusterId", flex: 1,
          renderCell: params => {
            return (
              <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                {params.row.clusterId}
              </MDTypography>
            );
          }
        },
        {
          headerName: "Ad", field: "name", flex: 1,
          renderCell: params => {
            return (
              <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                {params.row.name}
              </MDTypography>
            );
          }
        },
        {
          headerName: "Soyad", field: "surname", flex: 1,
          renderCell: params => {
            return (
              <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                {params.row.surname}
              </MDTypography>
            );
          }
        },
        {
          headerName: "Telefon",
          field: "phone",
          flex: 1,
          renderCell: (params) => (
            <MDTypography color="text" fontWeight="regular" fontSize="12px">
              {formatTRPhone(params.row.phone)}
            </MDTypography>
          ),
        },
        {
          headerName: "Email", field: "email", flex: 1,
          renderCell: params => {
            return (
              <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                {params.row.email}
              </MDTypography>
            );
          }
        },
        {
          headerName: "Oluşma Tarihi",
          field: "insertDate",
          flex: 1,
          renderCell: (params) => (
            <MDTypography color="text" fontWeight="regular" fontSize="12px">
              {params.row.insertDate
                ? moment(params.row.insertDate).format("DD.MM.YYYY - HH:mm")
                : "-"}
            </MDTypography>
          ),
        },
        {
          headerName: "Detay",
          field: "action",
          flex: 1,
          disableExport: true,
          sortable: false,
          filterable: false,
          renderCell: (params) => {
            return (
              <Stack
                direction="column"
                spacing={1}
                sx={{ width: "80%" }}
              >
                <Button
                  fullWidth
                  size="small"
                  variant="contained"
                  startIcon={<EditIcon fontSize="small" />}
                  style={{ backgroundColor: 'blue', color: 'white' }}
                  onClick={() => {
                    setEditUserDialogOpen(true);
                    setSelectedUser(params.row);
                    setName(params.row.name);
                    setSurName(params.row.surname);
                    setPhone(backendToInputPhone(params.row.phone));
                    setEmail(params.row.email);
                    setClusterId(params.row.clusterId);
                  }}
                >
                  Güncelle
                </Button>

                <Button
                  fullWidth
                  size="small"
                  variant="contained"
                  startIcon={<DeleteOutlineIcon fontSize="small" />}
                  style={{ backgroundColor: 'red', color: 'white' }}
                  onClick={() => {
                    setDeleteUserDialogOpen(true);
                    setSelectedUser(params.row);
                  }}
                >
                  Sil
                </Button>
              </Stack>

            );
          },
        }

      ]);

    };

    createRowsAndColoumns();
  }, [list]);

  const getUserGroupAdmin2FAList = async e => {

    const getUserGroupAdmin2FAListResponse = await UserManagementAPI.GetUserGroupAdmin2FAList(groupEuId);
    if (
      checkResponse(
        getUserGroupAdmin2FAListResponse,
        null,
        "Kullanıcı bilgileri getirme işlemi başarısız oldu.Lütfen Tekrar deneyin."
      )
    ) {
      if (getUserGroupAdmin2FAListResponse.data.resultObject.length > 0) {
        setList(getUserGroupAdmin2FAListResponse.data.resultObject);
      }
    }
  }

  const insertUserGroupAdmin2FA = async e => {

    if (!validatePhone(phone)) {
      alertErrorText("Telefon formatı yanlış");
      return;
    }

    const insertUserGroupAdmin2FAResponse = await UserManagementAPI.InsertUserGroupAdmin2FA(
      groupEuId,
      name,
      surName,
      inputToBackendPhone(phone),
      email);

    const spResult = insertUserGroupAdmin2FAResponse?.data?.resultObject;

    if (spResult === 1) {
      alertSuccessText("Başarılı");
      resetEditUserDialog();
      getUserGroupAdmin2FAList();
      return;
    }

    if (spResult === -2) {
      alertErrorText("Girilen telefon numarası sistemde kayıtlıdır. Lütfen başka bir numara giriniz");
      return;
    }

    alertErrorText(`Kayıt eklenemedi. (Kod: ${spResult})`);
  }

  const updateUserGroupAdmin2FA = async e => {

    if (!validatePhone(phone)) {
      alertErrorText("Telefon formatı yanlış");
      return;
    }

    const updateUserGroupAdmin2FAResponse = await UserManagementAPI.UpdateUserGroupAdmin2FA(clusterId,
      groupEuId,
      name,
      surName,
      inputToBackendPhone(phone),
      email);

    const spResult = updateUserGroupAdmin2FAResponse?.data?.resultObject;

    if (spResult === 1) {
      alertSuccessText("Başarılı");
      resetEditUserDialog();
      getUserGroupAdmin2FAList();
      return;
    }

    if (spResult === -2) {
      alertErrorText("Girilen telefon numarası sistemde kayıtlıdır. Lütfen başka bir numara giriniz");
      return;
    }

    alertErrorText(`Güncelleme yapılamadı. (Kod: ${spResult})`);
  }

  const deleteUserGroupAdmin2FA = async e => {

    const deleteUserGroupAdmin2FAResponse = await UserManagementAPI.DeleteUserGroupAdmin2FA(selectedUser.clusterId);
    if (
      checkResponse(
        deleteUserGroupAdmin2FAResponse,
        null,
        "Şifre gönderme işlemi başarısız oldu.Lütfen Tekrar deneyin."
      )
    ) {
      if (deleteUserGroupAdmin2FAResponse.data.resultObject > 0) {
        alertSuccessText("Başarılı");
        resetDeleteUserDialog();
        getUserGroupAdmin2FAList();
      }
    }
  }

  useEffect(() => {

    getUserGroupAdmin2FAList();

  }, []);

  const resetEditUserDialog = async () => {
    setClusterId(0);
    setName("");
    setSurName("");
    setPhone("");
    setEmail("");
    setSelectedUser(null);
    setEditUserDialogOpen(false);
  };

  const resetDeleteUserDialog = async () => {
    setSelectedUser(null);
    setDeleteUserDialogOpen(false);
  };

  const addOrUpdateUser = async () => {

    if (selectedUser === null) {
      insertUserGroupAdmin2FA();
    } else {
      updateUserGroupAdmin2FA();
    }

  };

  // Backend'ten gelen -> Input
  const backendToInputPhone = (value) => {
    if (!value) return "";
    const digits = value.replace(/\D/g, "");
    return digits.startsWith("0090") ? digits.slice(4, 14) : digits.slice(0, 10);
  };

  // Input -> Backend'e gidecek
  const inputToBackendPhone = (value) => {
    const digits = value.replace(/\D/g, "").slice(0, 10);
    return digits.length === 10 ? `0090${digits}` : "";
  };

  const [errorPhone, setErrorPhone] = useState(false);

  const validatePhone = () => {
    let err = "";

    const p = (phone || "").trim();
    const digits = p.replace(/\D/g, "");
    if (!digits) {
      err = "Telefon alanı boş olamaz.";
    } else if (digits.length > 10) {
      err = "Telefon 10 haneden fazla olamaz.";
    } else if (digits.length < 10) {
      err = "Telefon 10 haneli olmalı.";
    } else if (!digits.startsWith("5")) {
      err = "Telefon 5 ile başlamalı.";
    }

    setErrorPhone(err);
    return Object.keys(err).length === 0;
  };

  useEffect(() => {
    const onRefresh = async () => {
      await getUserGroupAdmin2FAList();
    };

    window.addEventListener("pageRefreshRequested", onRefresh);
    return () => window.removeEventListener("pageRefreshRequested", onRefresh);
  }, [groupEuId]);


  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={3} pb={1}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={1}
                px={2}
                variant='gradient'
                bgColor='info'
                borderRadius='lg'
                coloredShadow='info'
              >
                <MDTypography variant='h6' color='white'>
                  Kullanıcı Numaraları
                </MDTypography>
              </MDBox>

              <MDBox pt={3} px={2} display="flex" justifyContent="flex-end">
                <Button
                  onClick={e => {
                    setEditUserDialogOpen(true);

                  }}
                  style={style.addUserManagementButtonStyle}
                >
                  Yeni Ekle
                  <Icon style={style.addIconStyle} fontSize='small'>
                    add_circle
                  </Icon>
                </Button>
              </MDBox>

              <MDBox pt={3}>
                <CustomExport
                  rows={rows}
                  columns={columns}
                  exportFileName={userName
                    + "_RaporDosyaIndirmeListesi_"
                    + moment(new Date()).format('YYYYMMDDHHmmss').toString()}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Dialog open={editUserDialogOpen} fullWidth={true} maxWidth='md'>
        <DialogTitle>
          {selectedUser === null ? "Kullanıcı Ekle" : "Kullanıcı Düzenle"}
        </DialogTitle>
        <DialogContent>
          <MDBox pt={3} pb={1}>
            <div style={rowStyle}>
              <h6 style={labelStyle}>Ad :</h6>
              <div style={inputWrapStyle}>
                <MDInput
                  style={{ ...style.dialogInputStyle, width: "100%" }}
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
            </div>

            <div style={rowStyle}>
              <h6 style={labelStyle}>Soyad :</h6>
              <div style={inputWrapStyle}>
                <MDInput
                  style={{ ...style.dialogInputStyle, width: "100%" }}
                  type="text"
                  value={surName}
                  onChange={(e) => setSurName(e.target.value)}
                />
              </div>
            </div>

            <div style={rowStyle}>
              <h6 style={labelStyle}>Telefon :</h6>
              <div style={inputWrapStyle}>
                <MDInput
                  style={{ ...style.dialogInputStyle, width: "100%" }}
                  label="Telefon (10 hane)"
                  placeholder="5325554615"
                  value={phone}
                  onChange={(e) => {
                    const digits = (e.target.value || "").replace(/\D/g, "").slice(0, 10);
                    setPhone(digits);
                  }}
                  error={!!errorPhone}
                  helperText={errorPhone || " "}
                />
              </div>
            </div>

            <div style={rowStyle}>
              <h6 style={labelStyle}>Email :</h6>
              <div style={inputWrapStyle}>
                <MDInput
                  style={{ ...style.dialogInputStyle, width: "100%" }}
                  type="text"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={e => {
              resetEditUserDialog()
            }}
            style={{ color: 'red' }}
            autoFocus
          >
            Vazgeç
          </Button>
          <Button
            onClick={addOrUpdateUser}
            variant="contained"
            style={{ backgroundColor: 'blue', color: 'white' }}
          >
            {selectedUser === null ? "Ekle" : "Güncelle"}
          </Button>

        </DialogActions>
      </Dialog>

      <Dialog open={deleteUserDialogOpen} fullWidth={true} maxWidth='md'>
        <DialogContent>Silmek İstediğinize Emin Misiniz ?</DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              resetDeleteUserDialog();
            }}
            style={{ color: 'red' }}
          >
            Vazgeç
          </Button>
          <Button variant='gradient' style={{ color: '#6ed911' }} onClick={deleteUserGroupAdmin2FA}>
            Eminim
          </Button>
        </DialogActions>
      </Dialog>

    </DashboardLayout>
  );
}

export default UserManagement;
